/**
 * Module: ADVANCED-SEARCH
 * Description: TBD
 * Version: 3.0.2020.07281
 */

import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";

import { NgxSliderModule } from "@m0t0r/ngx-slider";

import { SharedLibraryModule } from "../shared-library/shared-library.module";

import { AdvancedSearchComponent } from "./advanced-search.component";
import { MultipleChoiceFacetComponent } from "./form-controls/multiple-choice-facet/multiple-choice-facet.component";
import { SingleChoiceFacetComponent } from "./form-controls/single-choice-facet/single-choice-facet.component";
import { ContentSearchComponent } from "./modules/content-search/content-search.component";
import { DirectoryItemDetailsCardComponent } from "./modules/directory-search/components/directory-item-details-card/directory-item-details-card.component";
import { DirectorySearchFiltersComponent } from "./modules/directory-search/components/directory-search-filters/directory-search-filters.component";
import { DirectorySearchResultsListViewComponent } from "./modules/directory-search/components/directory-search-results-list-view/directory-search-results-list-view.component";
import { GoogleMapComponent } from "./modules/directory-search/components/google-map/google-map.component";
import { DirectorySearchComponent } from "./modules/directory-search/directory-search.component";
import { MarketplaceItemDetailsCardComponent } from "./modules/marketplace-search/components/marketplace-item-details-card/marketplace-item-details-card.component";
import { MarketplaceSearchFiltersComponent } from "./modules/marketplace-search/components/marketplace-search-filters/marketplace-search-filters.component";
import { MarketplaceSearchResultsListViewComponent } from "./modules/marketplace-search/components/marketplace-search-results-list-view/marketplace-search-results-list-view.component";
import { PriceRangeFilterComponent } from "./modules/marketplace-search/form-controls/price-range-filter/price-range-filter.component";
import { MarketplaceSearchComponent } from "./modules/marketplace-search/marketplace-search.component";
import { YouTubePlayerModule } from "@angular/youtube-player";

@NgModule({
    declarations: [
        AdvancedSearchComponent,
        MultipleChoiceFacetComponent,
        SingleChoiceFacetComponent,
        ContentSearchComponent,
        DirectoryItemDetailsCardComponent,
        DirectorySearchFiltersComponent,
        DirectorySearchResultsListViewComponent,
        GoogleMapComponent,
        DirectorySearchComponent,
        MarketplaceItemDetailsCardComponent,
        MarketplaceSearchFiltersComponent,
        MarketplaceSearchResultsListViewComponent,
        PriceRangeFilterComponent,
        MarketplaceSearchComponent
    ],
    imports: [
        A11yModule,
        OverlayModule,
        PortalModule,
        CommonModule,
        ReactiveFormsModule,
        GoogleMapsModule,
        NoopAnimationsModule,
        NgxSliderModule,
        SharedLibraryModule,
        YouTubePlayerModule
    ],
    providers: [
        DatePipe
    ]
})
export class AdvancedSearchModule {
}
